<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Product group was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Product Class - {{ this.productClass.name }}</h1>
    <app-audit-line [data]='this.productClass'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-product-class-form [productClass]='this.productClass'></app-product-class-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/warehousing/product-classes'>Cancel</button>
    </form>
  </div>
</div>
